import React from 'react';
import { estiloEstado } from './estadosPartido';

// Caja de filtros (encima de la cabecera): ver todos los partidos o solo los
// de un estado. Cada opción muestra "n / N": partidos de ese estado sobre el
// total del jugador.
export default function FiltrosPartidos({ opciones, total, seleccionado, estados, onSeleccionar }) {
  return (
    <section className="mz-filtros" aria-label="Filtros de partidos">
      <h3 className="mz-filtros-titulo">Mis partidos</h3>
      <div className="mz-filtros-opciones" role="group" aria-label="Filtrar por estado">
        <button
          type="button" className={`mz-filtro${seleccionado === null ? ' mz-filtro-activo' : ''}`}
          aria-pressed={seleccionado === null} onClick={() => onSeleccionar(null)}
        >
          Todos <span className="mz-filtro-cuenta">{total} / {total}</span>
        </button>
        {opciones.map((o) => (
          <button
            key={o.codigo} type="button"
            className={`mz-filtro${seleccionado === o.codigo ? ' mz-filtro-activo' : ''}`}
            style={seleccionado === o.codigo ? estiloEstado(estados[o.codigo]) : undefined}
            aria-pressed={seleccionado === o.codigo} onClick={() => onSeleccionar(o.codigo)}
          >
            {o.etiqueta} <span className="mz-filtro-cuenta">{o.n} / {total}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
